/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.StartPortResponseDto>>;
export function request(params: API.tms.startPort.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/startPort/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
